module.exports = __webpack_public_path__ + "img/standup.e99d115a.jpg";